import axios from "axios";
import { I18n } from "react-redux-i18n";
import {
  SEARCH_MISS_LIST_ATTEMPT,
  SEARCH_MISS_LIST_SUCCESS,
  SEARCH_MISS_LIST_FAILED,
  SEARCH_MISS_NEW_ATTEMPT,
  SEARCH_MISS_NEW_SUCCESS,
  SEARCH_MISS_NEW_FAILED,
  SEARCH_MISS_WANT_ATTEMPT,
  SEARCH_MISS_WANT_SUCCESS,
  SEARCH_MISS_WANT_FAILED,
} from "../types/searchMissTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

function upsertItem(list, item) {
  const next = list.filter((row) => row.Id !== item.Id);
  return [item, ...next];
}

export const loadList = (data) => async (dispatch) => {
  dispatch({ type: SEARCH_MISS_LIST_ATTEMPT });
  await axios
    .get(url_api + "searchmiss", {
      params: {
        id: data.user_id,
        lang: I18n.t("locale"),
      },
      headers: { Authorization: `Bearer ${data.token}` },
    })
    .then((response) => {
      if (response.status < 300 && response.data.status === "Success") {
        dispatch({
          type: SEARCH_MISS_LIST_SUCCESS,
          data: response.data.body,
        });
      } else {
        dispatch({
          type: SEARCH_MISS_LIST_FAILED,
          error: response.data.body || "try_later",
        });
      }
    })
    .catch(() => {
      dispatch({ type: SEARCH_MISS_LIST_FAILED, error: "try_later" });
    });
};

export const newItem = (data) => async (dispatch) => {
  dispatch({ type: SEARCH_MISS_NEW_ATTEMPT });
  await axios
    .post(
      url_api + "searchmiss",
      {
        text: data.text,
        id: data.user_id,
        lang: I18n.t("locale"),
      },
      { headers: { Authorization: `Bearer ${data.token}` } }
    )
    .then((response) => {
      if (response.status < 300 && response.data.status === "Success") {
        dispatch({
          type: SEARCH_MISS_NEW_SUCCESS,
          item: response.data.body,
        });
      } else {
        dispatch({
          type: SEARCH_MISS_NEW_FAILED,
          error: response.data.body || "try_later",
        });
      }
    })
    .catch(() => {
      dispatch({ type: SEARCH_MISS_NEW_FAILED, error: "try_later" });
    });
};

export const addWant = (data) => async (dispatch) => {
  dispatch({ type: SEARCH_MISS_WANT_ATTEMPT, id: data.search_miss_id });
  await axios
    .post(
      url_api + "searchmiss/want",
      {
        search_miss_id: data.search_miss_id,
        id: data.user_id,
        lang: I18n.t("locale"),
      },
      { headers: { Authorization: `Bearer ${data.token}` } }
    )
    .then((response) => {
      if (response.status < 300 && response.data.status === "Success") {
        dispatch({
          type: SEARCH_MISS_WANT_SUCCESS,
          item: response.data.body,
        });
      } else {
        dispatch({
          type: SEARCH_MISS_WANT_FAILED,
          error: response.data.body || "try_later",
        });
      }
    })
    .catch(() => {
      dispatch({ type: SEARCH_MISS_WANT_FAILED, error: "try_later" });
    });
};

export { upsertItem };
